import { render, staticRenderFns } from "./RuleValidator.vue?vue&type=template&id=4b31d390&"
import script from "./RuleValidator.vue?vue&type=script&lang=ts&"
export * from "./RuleValidator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports